/**
 * API Keys Service
 */
import { apiClient } from '../client';
import type {
  APIKey,
  APIKeyCreate,
  APIKeyCreateResponse,
  APIKeysListResponse,
} from '../../types';

const BASE_PATH = '/api/api-keys';

export const apiKeysService = {
  /**
   * List user's API keys
   */
  listKeys: async (): Promise<APIKey[]> => {
    const response = await apiClient.get<APIKeysListResponse>(BASE_PATH);
    return response.data.keys;
  },

  /**
   * Create a new API key
   */
  createKey: async (data: APIKeyCreate): Promise<APIKeyCreateResponse> => {
    const response = await apiClient.post<APIKeyCreateResponse>(BASE_PATH, data);
    return response.data;
  },

  /**
   * Get a specific API key
   */
  getKey: async (keyId: number): Promise<APIKey> => {
    const response = await apiClient.get<APIKey>(`${BASE_PATH}/${keyId}`);
    return response.data;
  },

  /**
   * Revoke (deactivate) an API key
   */
  revokeKey: async (keyId: number): Promise<{ message: string; key_id: number }> => {
    const response = await apiClient.delete(`${BASE_PATH}/${keyId}`);
    return response.data;
  },
};
